import React, { useState, useEffect } from "react";
import { makeStyles, Box, Tooltip } from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";
import _ from "lodash";
import { getBrokerInformation } from "../../store/broker";
import { useDispatch, useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  tabpanel: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(400px, 1fr) );",
    gridGap: "0px",
    width: "100%",
    padding: "0 2rem ",
    overflowY: "auto",
    maxHeight: "72vh",
    overflowWrap: "break-word",
    scrollBehavior: "smooth",
    boxSizing: "content-box",
  },
}));

function TabPanel(props) {
  const {
    children,
    card,
    value,
    index,
    buildingIndex,
    buildingKey,
    buildingData,
    locationCovers,
    locNum,
    setValue,
    covertable,
    cardname,
    isEditBinder,
    onSubmit,
    handleSubmit,
    responseid,
    setUpdating,
    getUpdating,
    ...other
  } = props;

  const classes = useStyles();
  const [disable, setDisable] = useState(false);
  let { information } = useSelector(getBrokerInformation);
  const languagepreference = information.languagepreference;

  // const tempCard = card.map((data) => {
  //   return {
  //     ...data,
  //     name: { en: data?.name, fr: data?.frname },
  //     definition: { en: data?.definition, fr: data?.frdefinition },
  //   };
  // });
  const tempCard = card;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box className={classes.tabpanel}>
          {Object.values(tempCard).map((cover, index) => {
            if (
              cardname.toUpperCase().includes("LOCATION") &&
              locationCovers?.[cover.id] &&
              locationCovers[cover.id] != cover.covervalue
            ) {
              // possible place to add assignment of locations
              cover = { ...cover, covervalue: locationCovers[cover.id] };
            }

            if (
              cardname.toUpperCase().includes("LOCATION") &&
              buildingData?.[cover.id] &&
              buildingData[cover.id] != cover.covervalue
            ) {
              cover = { ...cover, covervalue: buildingData[cover.id] };
            }

            return (
              <form
                key={index}
                id="form"
                onSubmit={
                  responseid != undefined
                    ? null
                    : handleSubmit && handleSubmit(onSubmit)
                }
              >
                <div
                  className="form-group row my-2"
                  style={{ alignItems: "center" }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "60%",
                    }}
                  >
                    <label
                      className="col-sm-7 col-form-label"
                      style={{
                        fontFamily: "GibsonRegular",
                        marginTop: "2px",
                        maxWidth: "100%",
                      }}
                    >
                      {cover?.name[languagepreference]}
                    </label>
                    <Tooltip
                      title={cover?.definition[languagepreference]}
                      arrow
                    >
                      <InfoIcon />
                    </Tooltip>
                  </div>
                  <input
                    className="col-sm-4 form-control"
                    type={
                      cover.inputvaluetype
                        ? cover.inputvaluetype.toLowerCase() == "date"
                          ? "date"
                          : cover.inputvaluetype.toLowerCase() == "currency" ||
                            cover.inputvaluetype.toLowerCase() === "percent2f"
                          ? "number"
                          : "text"
                        : "text"
                    }
                    step={
                      cover.inputvaluetype
                        ? cover.inputvaluetype.toLowerCase() == "currency" ||
                          cover.inputvaluetype.toLowerCase() === "percent2f"
                          ? "0.01"
                          : "1"
                        : "1"
                    }
                    defaultValue={cover.covervalue}
                    onBlur={(event) => {
                      // setUpdating(true);
                      setDisable(true);
                      setTimeout(() => {
                        let ValuePass = null;
                        if (
                          ["percent", "currency", "percent2f"].includes(
                            cover.inputvaluetype.toLowerCase()
                          )
                        ) {
                          ValuePass = Number(
                            event.target.value.replace(/\D+/g, "")
                          );

                          if (
                            cover.inputvaluetype.toLowerCase() === "percent2f"
                          ) {
                            // Assuming the input is entered as a whole number (e.g., 50 for 50%)
                            // Convert it to a decimal (e.g., 0.50 for 50%)
                            ValuePass = ValuePass / 100;
                          }

                          if (isNaN(ValuePass)) {
                            ValuePass = event.target.value;
                          }
                        } else {
                          ValuePass = event.target.value;
                        }
                        setValue({
                          value: ValuePass,
                          id: cover.id,
                          isLocCov: cardname.toUpperCase().includes("LOCATION")
                            ? true
                            : false,
                          locNum: locNum,
                          card: card,
                        });
                        // setUpdating(false);
                        setDisable(false);
                      }, 400);
                    }}
                    disabled={disable || isEditBinder}
                  />
                </div>
              </form>
            );
          })}
        </Box>
      )}
    </div>
  );
}
export default TabPanel;
